export const fieldKeys = {
  BeneficiaryAccountName: "beneficiaryAccountName",
  BankName: "bankName",
  BankAccountNumber: "bankAccountNumber",
  SwiftId: "SwiftId",
  IBAN: "IBAN",
  BankIdNbr: "BankIdNbr",
  BranchId: "BranchId",
  PaymentMessage: "PaymentMessage",
} as const;

export type FieldKey = (typeof fieldKeys)[keyof typeof fieldKeys];
